import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFooterVisibility, setSmallHeaderVisibility } from '../../selfservice/actions';

export interface UseHideGlobalFooterOptions {
  /**
   * Hiding the footer shows the small header on OmaElisa pages, set this to keep the normal header instead.
   */
  keepHeader?: boolean;
}

export const useHideGlobalFooter = ({ keepHeader = false }: UseHideGlobalFooterOptions = {}): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFooterVisibility(false));
    if (keepHeader) {
      dispatch(setSmallHeaderVisibility(false));
    }
    return () => {
      dispatch(setFooterVisibility(true));
      if (keepHeader) {
        dispatch(setSmallHeaderVisibility(true));
      }
    };
  }, [dispatch, keepHeader]);
};
